<script>
  import { onMount } from 'svelte';

  import queryString from 'query-string';

  import BenableLogo from '@components/BenableLogo.svelte';
  import MobileOptionsModal from '@components/MobileOptionsModal.svelte';
  import HeaderMenu from '@components/HeaderMenu.svelte';
  import RecRequestGroupModal from '@app-components/modal/RecRequestGroupModal.svelte';
  import SwitchAccountsModal from '@app-components/modal/SwitchAccountsModal.svelte';
  import Auth from '@utils/auth';
  import UserAjax from '@ajax/user';
  import Nudge from '@utils/nudge';

  import { goto } from '$app/navigation';

  import { browser } from '$app/environment';

  import { getGlobalStore } from '@stores/global';
  let recRequestGroupStore = getGlobalStore('recRequestGroupStore');

  export let currentUser;

  export let options = ['profile', 'signout', 'dashboard'];
  let settingsMenu = ['edit-profile', 'advanced-settings', 'cashback', 'account-settings', 'notification-settings'];
  let dashboardMenu = ['recent-viewers', 'tune-up', 'dashboard-cashback', 'brand-partners'];

  export let group;
  export let logoHref = '/';
  export let logoSrc = '/images/logo-black.svg';
  export let showImages = currentUser && currentUser.id;
  export let customOptionsSettings = [];
  export let icon = 'dots';
  export let currentPage;
  export let currentTab;
  export let hideDotsMenu = false;

  const settings = {
    'rec-request-group': {
      label: () => 'Quick-start quizzes',
      image: () => {
        return `<div style="width: 24px; height: 24px; position: relative"><img alt="quiz" src="/images/current_user_menu/quiz.png" srcset=" /images/current_user_menu/quiz.png 1x, /images/current_user_menu/quiz@2x.png 2x">${
          recRequestGroup.total_completed != recRequestGroup.count
            ? `<div style="position: absolute; background: #FF6D6D; border: 2px solid #F9F7FF; box-sizing: border-box; border-radius: 8px; width: 20px; height: 20px; top: -6px; left: 16px; color: white; font-weight: 500; font-size: 11px; line-height: 13px; padding-top: 1px; padding-left: 5px;">${
                recRequestGroup.count - recRequestGroup.total_completed
              }</div>`
            : ''
        }</div>`;
      },
      action: () => (showRecRequestQuizzes = true),
      requirements: () => recRequestGroup && recRequestGroup.id,
    },
    'list-view': {
      label: () => 'View list',
      image: () => '<img alt="view list" src="/images/current_user_menu/view-list.png" />',
      action: () => goto(group.path),
      requirements: () => group && group.id,
    },
    'edit-list': {
      label: () => 'Reorder list',
      image: () => '<img alt="reorder list" src="/images/profile/organize.svg" />',
      action: () => goto(`${group.path_with_user_id}/edit`),
      requirements: () => group && group.id,
    },
    'list-settings': {
      label: () => 'List settings',
      image: () => '<img alt="list settings" src="/images/current_user_menu/settings.png" />',
      action: () => goto(`${group.path_with_user_id}/settings/privacy`),
      requirements: () => group && group.id,
    },
    profile: {
      label: () => 'My profile',
      image: () => '<img alt="my profile" src="/images/current_user_menu/user.png" />',
      action: () => goto(currentUser.profile_path),
      requirements: () => currentUser && currentUser.id,
    },

    'edit-profile': {
      label: () => 'Edit profile',
      image: () => '<img alt="settings" src="/images/current_user_menu/settings.svg" />',
      action: () => goto(`/profiles/edit`),
      requirements: () => currentUser && currentUser.id,
    },

    'settings-submenu': {
      label: () => 'Settings',
      image: () => '<img alt="settings" src="/images/current_user_menu/settings.svg" />',
      action: () => showSettingsOptionMenu(),
      requirements: () => currentUser && currentUser.id,
    },
    dashboard: {
      label: () => 'Dashboard',
      image: () => '<img alt="dashboard" src="/images/dashboard.svg" />',
      action: () => showDashboardOptionMenu(),
      showRedDot: () => {
        return Nudge.get('menu_dashboard');
      },
      requirements: () => currentUser && currentUser.id,
    },
    import: {
      label: () => 'Import <span class="success-badge-menu">New</span>',
      image: () => '<img alt="settings" src="/images/current_user_menu/import.png" />',
      containerNameStyle: () => 'display: flex; align-items: center;',
      action: () => (location.href = '/import'),
      requirements: () => currentUser && currentUser.id && currentUser.tiktok_import_enabled,
    },
    bookmarks: {
      label: () => 'Bookmarks',
      image: () => '<img alt="my profile" src="/images/bookmark.svg" />',
      action: () => goto(`${currentUser.profile_path}/bookmarks`),
      requirements: () => currentUser && currentUser.id,
    },
    verification: {
      label: () => 'Get verified!',
      image: () => '<img alt="my profile" src="/images/Checkbox_Oval.png" />',
      action: () => handleGetVerified(),
      showRedDot: () => currentUser.suggest_to_verify == 'active',
      requirements: () => currentUser && currentUser.id && !currentUser.verified && currentUser.suggest_to_verify,
    },
    'advanced-settings': {
      label: () => 'Advanced settings',
      image: () => '<img alt="advanced settings" src="/images/current_user_menu/settings.svg" />',
      action: () => goto('/profiles/advanced_settings'),
      requirements: () => currentUser && currentUser.id,
    },
    signout: {
      label: () => 'Sign out',
      image: () => '<img alt="sign out" src="/images/current_user_menu/signout.png" />',
      action: () => Auth.signout(currentUser),
      requirements: () => currentUser && currentUser.id,
    },
    login: {
      label: () => 'Login',
      image: () => '<img alt="login" src="/images/logout.svg" />',
      action: () => goto('/login'),
      requirements: () => !currentUser || !currentUser.id,
    },
    'get-started': {
      label: () => 'Sign up',
      image: () => '<img alt="sign up" src="/images/logout.svg" />',
      action: () => goto('/get-started'),
      requirements: () => !currentUser || !currentUser.id,
    },
    line: {
      label: () => '<div style="border-bottom: 1px solid #7f7f7f; opacity: 0.08; width: 100%;"></div>',
      image: () => null,
      containerNameStyle: () => 'width: 100%',
      requirements: () => currentUser && currentUser.id,
    },
    cashback: {
      label: () => 'Cashback settings',
      image: () => '<img alt="cashback" src="/images/current_user_menu/cashback.svg" />',
      action: () => goto('/profiles/cashback'),
      requirements: () => currentUser && currentUser.id && currentUser.can_enable_affiliate_links,
    },
    'email-notifications': {
      label: () => 'Email notifications',
      image: () => '<img alt="email notifications" src="/images/current_user_menu/email.svg" />',
      action: () => goto('/profiles/notification_settings'),
      requirements: () => currentUser && currentUser.id,
    },
    'switch-accounts': {
      label: () => 'Switch accounts',
      image: () => '<img alt="switch" src="/images/current_user_menu/switch.svg" />',
      action: () => openSwitchAccountsModal(),
      requirements: () => currentUser && currentUser.id && !currentUser.email.includes('@demo.benable.com'),
    },
    'account-settings': {
      label: () => 'Account settings',
      image: () => '<img alt="email notifications" src="/images/current_user_menu/email.svg" />',
      action: () => goto('/profiles/account_settings'),
      requirements: () => currentUser && currentUser.id,
    },

    'notification-settings': {
      label: () => 'Notification settings',
      image: () =>
        '<img alt="email notifications" src="/images/current_user_menu/bell-solid.svg" style="color: #ae94f9;"/>',
      action: () => goto('/profiles/notification_settings'),
      requirements: () => currentUser && currentUser.id,
    },

    'recent-viewers': {
      label: () => 'Insights',
      image: () => '<img alt="recent viewers" src="/images/dashboard.svg" />',
      action: () => {
        Nudge.hide(currentUser, 'menu_insights');
        goto('/dashboard?tab=recent-viewers');
      },
      requirements: () => currentUser && currentUser.id,
      showRedDot: () => Nudge.get('menu_insights'),
    },
    'tune-up': {
      label: () => 'Tune-up',
      image: () => '<img alt="recent viewers" src="/images/dashboard/tune-up.svg" />',
      action: () => {
        Nudge.hide(currentUser, 'menu_tune_up');
        goto('/dashboard?tab=tune-up');
      },
      requirements: () => currentUser && currentUser.has_tune_up_record,
      showRedDot: () => Nudge.get('menu_tune_up'),
    },
    'dashboard-cashback': {
      label: () => 'Cashback',
      image: () => '<img alt="cashback" src="/images/dashboard/cashback.svg" />',
      action: () => goto('/dashboard?tab=cashback'),
      requirements: () => currentUser && currentUser.id,
    },
    'brand-partners': {
      label: () => 'Brand partners',
      image: () => '<img alt="settings" src="/images/dashboard/brand-partners.svg" />',
      action: () => goto('/dashboard?tab=brand-partners'),
      requirements: () => currentUser && currentUser.id,
    },
  };

  let showSettingsOptionMenu = () => {
    showSettingsMenu = true;
  };

  let handleGetVerified = function () {
    UserAjax.markVerificationRequestNudgeSeen(currentUser);
    currentUser.set({ ...currentUser, suggest_to_verify: 'inactive' });
    goto('/profiles/edit?get-verified=1');
  };

  let showDashboardOptionMenu = () => {
    showDashboardMenu = true;
    Nudge.hide(currentUser, 'menu_dashboard');
  };

  let optionSettings = [];
  let optionsMenu = false;
  let mobileOptionsFadeInDuration = 200;
  let mobileOptionsSlideIn = null;

  let queryParams = browser && queryString.parse(location.search);
  let showRecRequestQuizzes = queryParams.quizzes == '1';
  let recRequestGroup = recRequestGroupStore;

  let buildOptions = () => {
    optionSettings = [];
    [...customOptionsSettings, ...options].forEach((op) => {
      let settingsData = typeof op === 'object' ? op : settings[op];
      if (settingsData && (!settingsData.requirements || settingsData.requirements())) {
        optionSettings.push({
          label: settingsData.label(),
          showRedDot: settingsData.showRedDot,
          image: settingsData.image && showImages && settingsData.image(),
          key: op,
          fn: settingsData.action,
          containerNameStyle: settingsData.containerNameStyle && settingsData.containerNameStyle(),
        });
      }
    });
  };

  let settingsMenuOptions = [];
  let showSettingsMenu = false;
  let dashboardMenuOptions = [];
  let showDashboardMenu = false;
  const showUserSearch =
    currentUser &&
    currentUser.can_search_user &&
    (currentPage == 'my-profile' || currentPage == 'discover' || currentPage == 'profile');
  const searchStyleClass = currentPage == 'my-profile' ? 'user-search-margin-rt' : '';

  let buildSettingOptions = () => {
    settingsMenuOptions = [];

    [...settingsMenu].forEach((op) => {
      let settingsData = typeof op === 'object' ? op : settings[op];

      if (settingsData && (!settingsData.requirements || settingsData.requirements())) {
        settingsMenuOptions.push({
          label: settingsData.label(),
          image: settingsData.image && showImages && settingsData.image(),
          key: op,
          fn: settingsData.action,
          containerNameStyle: settingsData.containerNameStyle && settingsData.containerNameStyle(),
        });
      }
    });
  };

  let buildDashboardOptions = () => {
    dashboardMenuOptions = [];

    [...dashboardMenu].forEach((op) => {
      let settingsData = typeof op === 'object' ? op : settings[op];

      if (settingsData && (!settingsData.requirements || settingsData.requirements())) {
        dashboardMenuOptions.push({
          label: settingsData.label(),
          showRedDot: settingsData.showRedDot,
          image: settingsData.image && showImages && settingsData.image(),
          key: op,
          fn: settingsData.action,
          containerNameStyle: settingsData.containerNameStyle && settingsData.containerNameStyle(),
        });
      }
    });
  };

  const backToOptionsMenu = function () {
    // Show the options menu again, without fading out the modal overlay.
    // (We need to set fade to 0, and then put it back so it can fade
    // properly on the next transition)
    const oldMobileOptionsFadeInDuration = mobileOptionsFadeInDuration;
    mobileOptionsFadeInDuration = 0;

    showOptionsMenu();

    setTimeout(() => {
      mobileOptionsFadeInDuration = oldMobileOptionsFadeInDuration;
    }, 0);
  };

  let showOptionsMenu = function () {
    optionsMenu = true;
  };

  let hideOptionsMenu = function () {
    optionsMenu = false;
  };

  let toggleOptionsMenu = function () {
    if (optionsMenu) {
      hideOptionsMenu();
    } else {
      showOptionsMenu();
    }
  };

  let showSwitchAccountsModal = false;

  const openSwitchAccountsModal = () => {
    showSwitchAccountsModal = true;
  };

  let goBack = function () {
    if (!browser) {
      return;
    }

    if (window.socialViewReportLoaded && currentTab == 'recent-viewers') {
      window.socialViewReportLoaded = false;
      return goto(currentUser.profile_path);
    } else if (currentTab == 'wrapped-report') {
      return goto('/dashboard');
    }

    window.localStorage.setItem('mobileMenuShow', true);
    history.back();
  };

  buildOptions();
  onMount(() => {
    let unsubRecRequestGroup = recRequestGroup.subscribe((x) => {
      recRequestGroup = x;
      buildOptions();
      buildSettingOptions();
      buildDashboardOptions();
    });

    return () => {
      unsubRecRequestGroup();
    };
  });

  let goBackFromSettings = function () {
    showSettingsMenu = false;

    const oldMobileOptionsSlide = mobileOptionsSlideIn;
    mobileOptionsSlideIn = 'left';

    backToOptionsMenu();
    setTimeout(() => {
      mobileOptionsSlideIn = oldMobileOptionsSlide;
    }, 0);
  };

  let goBackFromDashboard = function () {
    showDashboardMenu = false;

    const oldMobileOptionsSlide = mobileOptionsSlideIn;
    mobileOptionsSlideIn = 'left';

    backToOptionsMenu();
    setTimeout(() => {
      mobileOptionsSlideIn = oldMobileOptionsSlide;
    }, 0);
  };

  let showMenuOnPageLoad = function () {
    if (!browser) {
      return;
    }

    let page = window.localStorage.getItem('mobileMenuPage');
    let show = window.localStorage.getItem('mobileMenuShow');
    let link = window.localStorage.getItem('mobileMenuPreviousPath');
    window.localStorage.removeItem('mobileMenuShow');

    if (!page || !show) {
      return;
    }

    if (link != window.location.href) {
      return;
    }

    if (settingsMenu.includes(page)) {
      showSettingsMenu = true;
    } else if (dashboardMenu.includes(page)) {
      showDashboardMenu = true;
    }

    window.localStorage.removeItem('mobileMenuPreviousPath');
    window.localStorage.removeItem('mobileMenuPage');
  };

  showMenuOnPageLoad();
</script>

<style style="text/scss" lang="scss">
  .m-header-container {
    align-content: center;
    padding: 20px 30px;
    z-index: 6;
    position: sticky;
    top: 0;
    background: white;
    margin-top: -10px;

    .m-logo {
      margin-top: 1px;
      margin-left: -2px;
      flex: 1;
    }
  }
  .m-header-container.dashboard {
    padding: 0px 30px;
  }

  .m-header-container.main {
    display: flex;
  }

  .user-search-margin-rt {
    margin-right: 20px;
  }
</style>

<MobileOptionsModal
  bind:showModal={optionsMenu}
  options={optionSettings}
  fadeInDuration={mobileOptionsFadeInDuration}
  slideIn={mobileOptionsSlideIn} />

<MobileOptionsModal
  title={'SETTINGS'}
  bind:showModal={showSettingsMenu}
  options={settingsMenuOptions}
  fadeInDuration={0}
  showBackButton={true}
  slideIn={'right'}
  goBack={goBackFromSettings} />

<MobileOptionsModal
  title={'DASHBOARD'}
  bind:showModal={showDashboardMenu}
  options={dashboardMenuOptions}
  fadeInDuration={0}
  showBackButton={true}
  slideIn={'right'}
  goBack={goBackFromDashboard} />

{#if options.indexOf('rec-request-group') != -1 && recRequestGroup && recRequestGroup.id && showRecRequestQuizzes}
  <RecRequestGroupModal mobile={true} bind:show={showRecRequestQuizzes} />
{/if}

{#if showSwitchAccountsModal}
  <SwitchAccountsModal
    mobile={true}
    slideIn={'right'}
    currentUser={currentUser}
    bind:showModal={showSwitchAccountsModal}
    on:step-one-back-clicked={goBackFromSettings} />
{/if}

{#if currentPage == 'dashboard'}
  <div class="m-header-container dashboard">
    <div class="mobile-header-wrapper--small_case">
      <a on:click={() => goBack()}>
        <svg width="16" height="18" viewBox="0 0 16 18" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M15 9H1" stroke="black" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
          <path d="M8 17L1 9L8 1" stroke="black" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
        </svg>
      </a>
      {#if currentTab == 'tune-up'}
        <div class="text">TUNE-UP</div>
      {:else if currentTab == 'recent-viewers'}
        <div class="text">INSIGHTS</div>
      {:else}
        <div class="text">{currentTab.replace('-', ' ')}</div>
      {/if}
      <HeaderMenu group={group} icon={icon} toggleOptionsMenu={toggleOptionsMenu} />
    </div>
  </div>
{:else}
  <div class="m-header-container main">
    <div class="m-logo">
      <BenableLogo href={logoHref} src={logoSrc} />
    </div>

    {#if showUserSearch}
      <div
        class="m-logo {searchStyleClass}"
        style="direction: rtl;"
        on:click|preventDefault|stopPropagation={() => {
          goto(`/search`);
        }}>
        <img
          src={currentUser && currentUser.can_global_search
            ? '/images/search-icon.svg'
            : '/images/user-search-purple.svg'}
          alt="search" />
      </div>
    {/if}
    <slot name="additional-actions" />

    {#if !hideDotsMenu && (optionSettings.length > 0 || customOptionsSettings.length > 0)}
      <HeaderMenu group={group} icon={icon} toggleOptionsMenu={toggleOptionsMenu} />
    {/if}
  </div>
{/if}
